// extracted by mini-css-extract-plugin
module.exports = {"container":"qq","heading":"rq","image":"sq","text":"tq","infoWrapper":"uq","info":"vq","link":"wq"};